import React from 'react'

const PhoneIcon = () => {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 7.375C7.61929 7.375 6.5 8.49429 6.5 9.875C6.5 11.2557 7.61929 12.375 9 12.375C10.3807 12.375 11.5 11.2557 11.5 9.875C11.5 8.49429 10.3807 7.375 9 7.375ZM7.75 9.875C7.75 9.18464 8.30964 8.625 9 8.625C9.69036 8.625 10.25 9.18464 10.25 9.875C10.25 10.5654 9.69036 11.125 9 11.125C8.30964 11.125 7.75 10.5654 7.75 9.875Z'
        fill='#575761'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.875 4.69651C0.875 2.45159 2.5042 0.499998 4.66695 0.5L13.333 0.500008C15.4958 0.500011 17.125 2.45159 17.125 4.69652L17.125 7.375H15.7289L16.5015 8.66277C16.9095 9.34271 17.125 10.1207 17.125 10.9137V15.5H0.875V10.9137C0.875 10.1207 1.0905 9.34271 1.49847 8.66277L2.27114 7.37498H0.875V4.69651ZM12.2323 7.375H14.2711L15.4297 9.30589C15.7211 9.79156 15.875 10.3473 15.875 10.9137V14.25H2.125V10.9137C2.125 10.3473 2.27893 9.79156 2.57033 9.30589L3.72888 7.37499H5.80521L5.80521 4.84955L12.2323 4.84956V7.375ZM4.66695 1.75C3.33158 1.75 2.125 2.99645 2.125 4.69651V6.12498L4.55521 6.12499L4.55521 3.59954L13.4823 3.59956V6.125H15.875L15.875 4.69652C15.875 2.99646 14.6684 1.75001 13.333 1.75001L4.66695 1.75Z'
        fill='#575761'
      />
    </svg>
  )
}

export default PhoneIcon
